
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { LogOut } from "lucide-react";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";

export function Navbar() {
  const { signOut } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut();
      toast.success("Logged out successfully");
      navigate("/login");
    } catch (error) {
      toast.error("Failed to log out");
      console.error("Logout error:", error);
    }
  };

  return (
    <div className="w-full bg-brand-primary text-white shadow-md py-3 px-4">
      <div className="container max-w-6xl mx-auto flex justify-between items-center">
        <div className="flex items-center">
          <img 
            src="/lovable-uploads/139c637a-b7d5-4be9-b11c-cb9336b22a10.png" 
            alt="Market Validator" 
            className="h-12 mr-4" 
          />
        </div>
        <Button 
          variant="outline" 
          onClick={handleLogout}
          className="flex items-center gap-2 bg-transparent border-white text-white hover:bg-white/10"
        >
          <LogOut size={16} />
          Logout
        </Button>
      </div>
    </div>
  );
}
